import React from "react";
import { useTranslation } from "react-i18next";
import { Row, Col } from "components/bootstrap";
import { DocumentTitle, PageHeader } from "components/common";
import DocsHelper from "util/DocsHelper";
import DataLakeConnectorsList from "./DataLakeConnectorsList";
const DataLakeConnectorsPage = () => {
  const { t } = useTranslation("enterprise_data_lake");
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("connectors_page.title") }, /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: t("connectors_page.title"),
      documentationLink: {
        title: t("connectors_page.documentation_link"),
        path: DocsHelper.PAGES.DATA_LAKE
      }
    },
    /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("p", null, t("connectors_page.description_connectors")), /* @__PURE__ */ React.createElement("p", null, t("connectors_page.description_explore")), /* @__PURE__ */ React.createElement("p", null, t("connectors_page.description_filtered_inputs")))
  ), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(DataLakeConnectorsList, null))));
};
export default DataLakeConnectorsPage;
